import { faCircleInfo, faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Pill } from '@/components/ui/pill/pill.component';
import { Icon } from '@/components/ui/icon.component';

interface ExamsCoverageBannerProps {
  matched: number;
  total: number;
  isFullCoverage: boolean;
  dataTestId?: string;
  onViewCoverage: () => void;
}

export const ExamsCoverageBanner = ({
  matched,
  total,
  isFullCoverage,
  dataTestId = DataTestIdEnum.SEARCH_CARD_LABORATORY_COVERAGE_BANNER,
  onViewCoverage,
}: ExamsCoverageBannerProps) => {
  return (
    <Pill
      variant={isFullCoverage ? 'info' : 'warning'}
      className={
        isFullCoverage
          ? 'w-full h-8 justify-center cursor-pointer border-blue-300 hover:bg-blue-100'
          : 'w-full h-8 justify-center cursor-pointer border-warning-300 text-warning-800'
      }
      asChild
      data-testid={dataTestId}
    >
      <button type="button" onClick={onViewCoverage}>
        <span className="flex h-4 w-4 items-center justify-center">
          <Icon icon={isFullCoverage ? faCircleInfo : faTriangleExclamation} size="xs" />
        </span>
        <span className="font-semibold text-base text-center">
          {isFullCoverage ? 'Atende todos os exames' : `Atende ${matched} dos ${total} exames`}
          {' - '}
          <span className="underline">Ver</span>
        </span>
      </button>
    </Pill>
  );
};
